import { useEffect, useRef } from 'react';
import PaperCard from '../card/PaperCard';
import PDFViewer from '../view/PDFViewer';
import { Divider } from 'antd'
import VideoCard from '../card/VideoCard';
const dataConference = [
    {
        title: 'Virtual reality safety training on multiple platforms', isAuthor: true, name: 'ICCEPM', color: ['#bdc3c7', '#2c3e50'],
        url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/Virtual+reality+safety+training+on+multiple+platforms.pdf'
    },
    {
        title: 'Skeleton Model-based Unsafe Behaviors Detection at construction site scaffold', isAuthor: false, name: 'ICCEPM', color: ['#bdc3c7', '#2c3e50'],
        url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/Skeleton+Model-Based+Unsafe+Behaviors+Detection+at+a+Construction+Site+Scaffold.pdf'
    },
    {
        title: 'A framework for computer vision-aided construction safety monitoring using collaborative 4D BIM ', isAuthor: false, name: 'ICCEPM', color: ['#bdc3c7', '#2c3e50'],
        url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/A+framework+for+computer+vision-aided+construction+safety+monitoring+using+collaborative+4D+BIM+.pdf'
    },
    {
        title: 'Sharing VR safety content based on Non-fungible Tokens', isAuthor: true, name: 'CONVR', color: ['#fff8de', '#ffc800'],
        url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/Sharing+VR+safety+content+based+on+Non-fungible+Tokens.pdf'
    },
    {
        title: 'Development of Computer Vision and BIM-cloud Based Automated Status Updating for Construction Safety Monitoring', isAuthor: false, name: 'CONVR', color: ['#fff8de', '#ffc800'],
        url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/Development+of+Computer+Vision+and+BIM-cloud+Based+Automated+Status+Updating+for+Construction+Safety+Monitoring.pdf'
    },
    {
        title: 'UNSAFE ACTION DETECTION AT A CONSTRUCTION SITE A-TYPE LADDER', isAuthor: false, name: 'CONVR', color: ['#fff8de', '#ffc800'],
        url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/UNSAFE+ACTION+DETECTION+AT+A+CONSTRUCTION+SITE+A-TYPE+LADDER.pdf'
    },
    {
        title: 'Rule based 4D-BIM system for visualizing hazard zone', isAuthor: false, name: 'CONVR', color: ['#fff8de', '#ffc800'],
        url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/Rule+based+4D-BIM+system+for+visualizing+hazard+zone.pdf'
    }
]
const dataJournal = [
    {
        title: 'Leveraging Blockchain for Scaffolding Work Management in Construction', isAuthor: false, name: 'IEEE Access', color: ['#1c92d2', '#f2fcfe'], position:[0,0,0]
        , url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/Leveraging_Blockchain_for_Scaffolding_Work_Management_in_Construction.pdf'
    },
    {
        title: 'Cross-platform virtual reality for real-time construction safety training using immersive web and industry foundation classes', position:[10,-10,-10],
        isAuthor: true, name: 'Automation in Construction', color: ['#48b711', '#f2fcfe']
        , url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/paper/Cross-platform+virtual+reality.pdf'
    }
]
const dataHackathon = [
    {
        title: '22nd International Conference on Construction Applications of Virtual Reality', result: '2nd Prize', name: 'IEEE Access', color: ['#1c92d2', '#f2fcfe']
        , url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/model/youtube_logo.glb' , vidUrl:'https://www.youtube.com/watch?v=QDvAAOsbiQM'
    },
    {
        title: '2022 Virtual Forge Hackathon',
        result: 'Nomination', name: 'Automation in Construction', color: ['#1c92d2', '#f2fcfe']
        , url: 'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/model/youtube_logo.glb', vidUrl:'https://www.youtube.com/watch?v=3jzE-DlPYns'
    }
]
export default function PaperPage() {


    useEffect(() => {

    }, []);

    return (
        <div style={{ height: 'calc(100vh - 70px)' }}>
            {/* <PDFViewer /> */}
            <div >
                <div>
                    <div className='bql-paper-header'  >
                        <span >
                            Journal
                        </span>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }} >
                        {dataJournal.map(i =>
                            <PaperCard {...i} />
                        )}

                    </div>
                </div>
                <Divider />
                <div>
                    <div className='bql-paper-header'  >
                        <span >
                            Conference
                        </span>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap' }} >
                        {dataConference.map(i =>
                            <PaperCard {...i} />
                        )}

                    </div>
                </div>
                <div className='bql-paper-header'  >
                        <span >
                            Hackathon
                        </span>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap' }} >
                    {dataHackathon.map(i =>
                            <VideoCard {...i} />
                        )}

                    </div>

            </div>

        </div>

    );
};